import type { InstallableApp } from "~/pwa/installableApps";

let defaultThemeColor: string | null | undefined;

const ensureThemeColorMeta = (): HTMLMetaElement => {
	let element = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
	if (!element) {
		element = document.createElement("meta");
		element.name = "theme-color";
		document.head.appendChild(element);
	}
	return element;
};

const applyModuleThemeColor = (app: InstallableApp | null): void => {
	if (typeof document === "undefined") return;
	if (defaultThemeColor === undefined) {
		defaultThemeColor = document.head.querySelector('meta[name="theme-color"]')?.getAttribute("content") ?? null;
	}
	const themeColor = app ? app.themeColor : defaultThemeColor;
	if (themeColor) ensureThemeColorMeta().setAttribute("content", themeColor);
};

export default applyModuleThemeColor;
